export const partColors = {
  0: 'light-violet',
  1: 'green',
  2: 'dark-orange',
  3: 'light-orange',
  4: 'yellow',
  5: 'pink',
  6: 'violet',
  7: 'light-blue',
  8: 'light-green',
  9: 'part9-light-blue',
  10: 'turqouise',
  11: 'purple',
  12: 'pale-pink',
  13: 'sqlgreen',
};
